/**
 * 河长左侧列表配置信息（默认场景）

 */
export const leftTabList = [
    {
        label: 'hezhang.index.leftAside.river',
        value: 'RIVER',
        checked: true,
    },
    {
        label: 'hezhang.index.leftAside.lakes',
        value: 'LAKE',
        checked: true,
    },
    {
        label: 'hezhang.index.leftAside.island',
        value: 'ISLAND',
        checked: true,
    },
    {
        label: 'hezhang.index.leftAside.project',
        value: 'PROJECT',
        checked: true,
    },
];

// 场景2：简化场景（仅保留事件和照片）
